"use client"

import type React from "react"

import { cn } from "@/lib/utils"

import type { Heading } from "./blog-post"

interface TableOfContentsProps {
  headings: Heading[]
  activeId: string
  setActiveId: (id: string) => void
}

export function TableOfContents({ headings, activeId, setActiveId }: TableOfContentsProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault()

    setActiveId(id)

    const element = document.getElementById(id)

    if (element) {
      const offset = 120
      const elementPosition = element.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.scrollY - offset

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      })

      history.pushState(null, "", `#${id}`)
    }
  }

  return (
    <nav className="space-y-1 border border-gray-200 rounded-lg p-6 mt-6">
      <h2 className="mb-4 text-sm font-semibold text-gold uppercase">Nesta página</h2>
      <ul className="space-y-2 text-sm">
        {headings.map((heading, index) => (
          <li key={heading.id + '-' + index} style={{ paddingLeft: `${(heading.level - 1) * 8}px` }}>
            <a
              href={`#${heading.id}`}
              onClick={(e) => handleClick(e, heading.id)}
              className={cn(
                "block py-1 text-muted-foreground transition-colors hover:text-foreground border-b border-white/10 pb-3",
                activeId === heading.id && "text-gold font-medium",
              )}
            >
              {heading.text}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  )
}
